import { useEffect, useState } from "react";

import { BidFavoriteContent, BidFavoriteFilter } from "@/types/bid";

import {
  BidFavoriteTabData,
  DefaultFavoriteFilter,
  ProjectType,
} from "@/consts/Bid";

import { GetBidFavoriteList } from "@/services/Bid";

import ContentLayout from "@/layouts/ContentLayout";

import BidFavoriteList from "@/pages/Bid/favorite/List";

import CommonTab from "@/components/Common/Tab";
import BidFavoriteSearch from "@/components/BidFavoriteSearch";

export default function BidFavorite() {
  const [bidContent, setBidContent] = useState<BidFavoriteContent>(
    {} as BidFavoriteContent
  );
  const [filter, setFilter] = useState<BidFavoriteFilter>({
    ...DefaultFavoriteFilter,
    project_type: ProjectType.Original,
  });

  const onSearch = async (searchFilter: BidFavoriteFilter) => {
    try {
      const params =
        `starred_projects = bid.notice.star.get_projects("${searchFilter.project_type}")\n` +
        `project_ids = [p.project_id for p in starred_projects.projects]\n` +
        `keyword_sets = [BidNoticeKeywordSet(${
          searchFilter.title
            ? `input_strings=["${searchFilter.title}"],` +
              ` title_or_doc="TITLE", or_and="OR"`
            : `input_strings=[""]`
        })]\n` +
        `search_request = BidNoticeSearchRequest(keyword_sets=keyword_sets, ` +
        `project_ids=project_ids, ` +
        `${searchFilter.dminst_filter ? `dminst_filter=["${searchFilter.dminst_filter}"],` : ``} ` +
        `sort_by="${searchFilter.sort_by}", ` +
        `order="${searchFilter.order}", ` +
        `project_type="${searchFilter.project_type}", ` +
        `category="${searchFilter.category}")\n` +
        `bid.notice.search_by_keywords(search_request)`;
      const result = await GetBidFavoriteList(params);
      setBidContent(result.data.pods[0].content);
    } catch (e) {
    } finally {
    }
  };

  useEffect(() => {
    onSearch(filter);
  }, []);

  return (
    <ContentLayout>
      <CommonTab variants="string" data={BidFavoriteTabData} />
      {bidContent && (
        <BidFavoriteSearch>
          <BidFavoriteList
            content={bidContent}
            onSearch={onSearch}
            filter={filter}
            setFilter={setFilter}
          />
        </BidFavoriteSearch>
      )}
    </ContentLayout>
  );
}
